const fontList = [
    "Roboto",
    "Mina",
    "Open Sans",
    "Lato",
    "Oswald",
    "Rammetto One",
    "Montserrat",
    "Source Sans Pro",
    "Rozha One",
    "Raleway",
    "PT Sans",
    "Roboto Slab",
    "Merriweather",
    "Limelight",
    "Ubuntu",
    "Playfair Display",
    // "Coda Caption",
    "Noto Sans",
    "Lora",
    "Poppins",
    "PT Serif",
    "Arimo",
    "Roboto Mono",
    "Karma",
    "Nunito",
    "Muli",
    "Anton",
    "Bitter",
    "Timmana"
];

export default fontList;


// WEBPACK FOOTER //
// ./src/fontlist.js